import { API_ENPOINTS } from '../../constants/api';
import { get, put, post, requestDelete, downloadBlob, uploadFile, uploadAllFiles } from '../../utils/requests';
import { serializeTest, deserializeTest, deserializeEnum } from './serializers';

const TEST_API = API_ENPOINTS.testManagement;
const TEST_API2 = API_ENPOINTS.testManagement2;

const addQueryParam = (name, value) => (value || value === false ? `&${name}=${value}` : '');

const ORDER_COLUMNS = {
  ContactName: 'contactName',
  StartDate: 'startDate',
  ContactEmail: 'contactEmail',
  Address: 'address',
  RadonAverage: 'averageRadon',
  Status: 'status',
  QC: 'QC',
  Tester: 'testerName',
  DeviceSN: 'deviceSN',
  InstrumentLocation: 'instrumentLocation',
};

const filtersToRequest = ({
  ClientName,
  Email,
  PostalCode,
  Address,
  TesterName,
  TestId,
  Start: startDate,
  End: endDate,
  completed,
  qc,
  CustomerNumber,
  SerialNumber,
  OrderColumn,
  OrderBy,
}) => {
  const Start = startDate && new Date(startDate.setHours(0, 0, 0, 0)).toISOString();
  const End = endDate && new Date(endDate.setHours(23, 59, 59, 999)).toISOString();
  const completedParam = typeof completed === 'boolean' ? completed.toString() : null;

  return {
    ClientName,
    Email,
    PostalCode,
    Address,
    TesterName,
    TestId,
    IsQC: qc,
    Start,
    End,
    Completed: completedParam,
    CustomerNumber,
    SerialNumber,
    orderColumn: ORDER_COLUMNS[OrderColumn],
    orderBy: OrderBy ? 'DESC' : 'ASC',
  };
};

export const requestToQueryParam = ({
  ClientName,
  Email,
  PostalCode,
  Address,
  TesterName,
  TestId,
  Start,
  End,
  Completed,
  IsQC,
  CustomerNumber,
  SerialNumber,
  orderColumn,
  orderBy,
}) => {
  return (
    addQueryParam('ClientName', ClientName) +
    addQueryParam('Email', Email) +
    addQueryParam('SerialNumber', SerialNumber) +
    addQueryParam('Address', Address) +
    addQueryParam('PostalCode', PostalCode) +
    addQueryParam('CustomerNumber', CustomerNumber) +
    addQueryParam('TesterName', TesterName) +
    addQueryParam('IsQC', IsQC) +
    addQueryParam('TestId', TestId) +
    addQueryParam('Start', Start) +
    addQueryParam('End', End) +
    addQueryParam('Completed', Completed) +
    addQueryParam('orderBy', orderBy) +
    addQueryParam('orderColumn', orderColumn)
  );
};

export const fetchTests = (page = 1, size = 20, filters) => {
  const request = filtersToRequest({
    ...filters,
  });

  const queryParams = requestToQueryParam(request);
  const endpoint = `${TEST_API2}/Search/?page=${page}&size=${size}${queryParams}`;

  return get(endpoint);
};

export const fetchTest = (id) => {
  const endpoint = `${TEST_API}/${id}`;
  return get(endpoint).then(deserializeTest);
};

export const updateTest = (id, test) => {
  const endpoint = `${TEST_API}/${id}`;
  return put(endpoint, serializeTest(test));
};

export const deleteTest = (id) => {
  const endpoint = `${TEST_API}/${id}`;
  return requestDelete(endpoint);
};

export const downloadChart = (id) => {
  const endpoint = `${TEST_API}/${id}/downloadChart`;
  return downloadBlob(endpoint);
};

export const downloadBulkReport = (request) => {
  const params = filtersToRequest(request);
  const endpoint = `${TEST_API}/bulkReport`;
  return downloadBlob(endpoint, 'POST', params);
};

export const downloadDetailedReport = (request) => {
  const params = filtersToRequest(request);
  const endpoint = `${TEST_API}/detailedReport`;
  return downloadBlob(endpoint, 'POST', params);
};

export const downloadReport = (id, layout) => {
  const endpoint = `${TEST_API}/${id}/downloadReport?layout=${layout}`;
  return downloadBlob(endpoint);
};

export const downloadCsv = (id) => {
  const endpoint = `${TEST_API}/${id}/downloadCsv`;
  return downloadBlob(endpoint);
};

export const downloadTxt = (id) => {
  const endpoint = `${TEST_API}/${id}/downloadTxt`;
  return downloadBlob(endpoint);
};

export const emailReport = (id, to, cc, layout, layoutId) => {
  const endpoint = `${TEST_API}/${id}/sendEmail`;
  return post(endpoint, {
    recipients: to,
    inCopy: cc,
    layout,
    layoutId,
  });
};

export const getDeviceTypes = () => {
  const endpoint = API_ENPOINTS.deviceTypes;
  return get(endpoint).then(deserializeEnum);
};

export const getQCDeviceTypes = () => {
  const endpoint = API_ENPOINTS.qcDeviceTypes;
  return get(endpoint).then(deserializeEnum);
};

export const fetchPhoto = (id) => {
  const endpoint = `${TEST_API}/${id}/Photo`;
  return get(endpoint);
};

export const updatePhoto = (id, index, file) => {
  const endpoint = `${TEST_API}/${id}/updatePhoto/${index}`;
  return uploadFile(endpoint, file);
};

export const deletePhoto = (id, index) => {
  const endpoint = `${TEST_API}/${id}/deletePhoto/${index}`;
  return post(endpoint);
};

export const syncWithIsn = (id) => {
  const endpoint = `${TEST_API}/${id}/SyncWithIsn`;
  return put(endpoint).then(() => {
    return fetchTest(id);
  });
};

export const updateFloorPlan = (id, index, file) => {
  const endpoint = `${TEST_API}/${id}/FloorPlan/${index}`;
  return uploadFile(endpoint, file);
};

export const updateAllFloorPlans = (id, files) => {
  const endpoint = `${TEST_API}/${id}/FloorPlan/batch`;
  return uploadAllFiles(endpoint, files);
};

export const deleteFloorPlan = (id, index) => {
  const endpoint = `${TEST_API}/${id}/FloorPlan/${index}`;
  return requestDelete(endpoint);
};

export const deleteAllFloorPlans = (id) => {
  const endpoint = `${TEST_API}/${id}/FloorPlan/batch`;
  return requestDelete(endpoint);
};

export const getFloorPlan = (id) => {
  const endpoint = `${TEST_API}/${id}/FloorPlan`;
  return downloadBlob(endpoint).then((data) => {
    if (data.size > 0) return new File([data], 'name', { type: data.type, lastModified: Date.now() });
  });
};



// WEBPACK FOOTER //
// src/actions/tests/apiRequests.js